<div class="wrapper">
	<cv-dropdown class="adjust-cv-dropdown-style"
							 [optionText]="'name'"
							 [options]="listItems"
							 [selectedValue]="selectedItem"
							 (openMenu)="onSelectListOpen()"
							 (closeMenu)="onSelectListClose()"
							 (valuesChange)="onValueChange($event)">
	</cv-dropdown>
</div>
